import React, { useEffect, useRef, useState } from 'react'
import { ErrorMessage, Field, Form, Formik } from 'formik';
import {getTextosConfig} from '../../services/denunciaService';
import { Col, Row } from 'reactstrap';

const Rights = () => {
    const [textosConfig, setTextosConfig] = useState([]);

    useEffect(() => {
        getTextoConfig();
    }, [])

    const getTextoConfig = async () => {
        const response = await getTextosConfig();
        setTextosConfig(response);
    }
    return (
        <div className="mb-5">
        {textosConfig.map(textos => (         
                <div>   
                {textos.key == "Responsable" ?
                <Row>
                <Col md="2"><h3>{textos.key}</h3></Col>                
                <Col><div className='mb-3 denuncia__textRights' dangerouslySetInnerHTML={{ __html: textos.value }}></div></Col>
                </Row>
                : ''}
                {textos.key == "Finalidad" ?
                <Row>
                <Col md="2"><h3>{textos.key}</h3></Col>                
                <Col><div className='mb-3 denuncia__textRights' dangerouslySetInnerHTML={{ __html: textos.value }}></div></Col>
                </Row>
                : ''}
                {textos.key == "Legitimación" ?
                <Row>
                <Col md="2"><h3>{textos.key}</h3></Col>                
                <Col><div className='mb-3 denuncia__textRights' dangerouslySetInnerHTML={{ __html: textos.value }}></div></Col>
                </Row>
                : ''}
                {textos.key == "Destinarios" ?
                <Row>
                <Col md="2"><h3>{textos.key}</h3></Col>                
                <Col><div className='mb-3 denuncia__textRights' dangerouslySetInnerHTML={{ __html: textos.value }}></div></Col>
                </Row>
                : ''}
                {textos.key == "Derechos" ?
                <Row>
                <Col md="2"><h3>{textos.key}</h3></Col>                
                <Col><div className='mb-3 denuncia__textRights' dangerouslySetInnerHTML={{ __html: textos.value }}></div></Col>
                </Row>
                : ''}
                </div>
            ))} 
        </div>
    )
}

export default Rights
